import {
  Box,
  Button,
  DestructiveIcon,
  ListItem,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';

interface ExcelFileExtensionErrorModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

export default function ExcelFileExtensionErrorModal({
  isOpen,
  onConfirm,
}: ExcelFileExtensionErrorModalProps) {
  return (
    <Modal isOpen={isOpen} maxWidth="xs" onClose={onConfirm}>
      <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />}>엑셀 업로드 실패</ModalTitle>
      <ModalContent>
        <Text textAlign="center">업로드할 수 없는 파일입니다. 다시 시도해 주세요.</Text>
        <Box
          as="ul"
          bg="boxBackgroundNeutralBase"
          border="1px solid"
          borderColor="boxBorderNeutralBase"
          mt={6}
          px={6}
          py={7}
        >
          <ListItem variant="square">
            <Text fontSize="sm">엑셀파일(.xlsx)만 업로드할 수 있습니다.</Text>
          </ListItem>
          <ListItem mt={2} variant="square">
            <Text fontSize="sm">다운 받은 양식 파일이 맞는지 확인해 주세요.</Text>
          </ListItem>
        </Box>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onConfirm}>확인</Button>
      </ModalFooter>
    </Modal>
  );
}
